import defaultTheme from './defaultTheme';

const teacherTheme = { ...defaultTheme };

export default teacherTheme;
